import { render, staticRenderFns } from "./adminClients.vue?vue&type=template&id=5031568b&"
import script from "./adminClients.vue?vue&type=script&lang=js&"
export * from "./adminClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports